<div class="dialog-content-max">
    <form [formGroup]="SignatoryForm">

        <div class="formgrid grid" style="margin-top: 1rem;">
            <div class="col-12 lg:col-6 md:col-6 sm:col-12">
                <div class="form-group">
                    <label for="user" class="required-label">Choose User</label>
                    <p-dropdown #userdropdown [options]="userlist" [filter]="true" appendTo="body"
                        optionLabel="firstname" (onChange)="onuserchange($event)" optionValue="userid"
                        placeholder="Select User" formControlName="user" [readonly]="onlyView" inputId="user"
                        name="user" checkmark="true" [showClear]="true" loading="true"
                        (onHide)="clearSearch(userdropdown)" variant="filled">
                    </p-dropdown>
                </div>
            </div>
        </div>

        <div class="formgrid grid" style="margin-top: 1rem;" *ngIf="!isSelected">
            <div class="col-12 lg:col-12 md:col-12 sm:col-12">
                <div class="form-group">
                    <label for="name" class="required-label">
                        User Name<span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 100
                            chars)</span><span>*</span></label>
                    <input pInputText pKeyFilter="text" class="form-control" inputId="name" id="name"
                        formControlName="name" name="name" placeholder="Enter User Name" maxlength="100" />
                    <span class="errormessage"
                        *ngIf="SignatoryForm.get('name').invalid && (SignatoryForm.get('name').touched  || SignatoryForm.get('name').dirty)">
                        {{getErrorMessage(SignatoryForm,validation_message,'name')}}
                    </span>
                </div>
            </div>
        </div>

        <div class="formgrid grid" style="margin-top: 1rem;" *ngIf="!isSelected">
            <div class="col-12 lg:col-12 md:col-12 sm:col-12">
                <div class="form-group">
                    <label for="email" class="required-label">
                        Email<span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 100
                            chars)</span><span>*</span></label>
                    <input pInputText pKeyFilter="text" class="form-control" inputId="email" id="email"
                        formControlName="email" name="email" placeholder="Enter Email" maxlength="100" />
                    <span class="errormessage"
                        *ngIf="SignatoryForm.get('email').invalid && (SignatoryForm.get('email').touched  || SignatoryForm.get('email').dirty)">
                        {{getErrorMessage(SignatoryForm,validation_message,'email')}}
                    </span>
                </div>
            </div>
        </div>

        <div class="formgrid grid" style="margin-top: 1rem;" *ngIf="isSelected">
            <div class="col-12 lg:col-12 md:col-12 sm:col-12">
                <div class="form-group">
                    <label for="name" class="required-label">
                        User Name<span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 100
                            chars)</span><span>*</span></label>
                    <input pInputText pKeyFilter="text" class="form-control" inputId="name" id="name"
                        formControlName="name" name="name" placeholder="Enter User Name" maxlength="100" readonly />
                </div>
                <span class="errormessage"
                    *ngIf="SignatoryForm.get('name').invalid && (SignatoryForm.get('name').touched  || SignatoryForm.get('name').dirty)">
                    {{getErrorMessage(SignatoryForm,validation_message,'name')}}
                </span>
            </div>
        </div>

        <div class="formgrid grid" style="margin-top: 1rem;" *ngIf="isSelected">
            <div class="col-12 lg:col-12 md:col-12 sm:col-12">
                <div class="form-group">
                    <label for="email" class="required-label">
                        Email<span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 100
                            chars)</span><span>*</span></label>
                    <input pInputText pKeyFilter="text" class="form-control" inputId="email" id="email"
                        formControlName="email" name="email" placeholder="Enter Email" maxlength="100" readonly />
                </div>
                <span class="errormessage"
                    *ngIf="SignatoryForm.get('email').invalid && (SignatoryForm.get('email').touched  || SignatoryForm.get('email').dirty) ">
                    {{getErrorMessage(SignatoryForm,validation_message,'email')}}
                </span>
            </div>
        </div>

        <div class="formgrid grid" style="margin-top: 1rem;">
            <div class="col-12 lg:col-4 md:col-4 sm:col-12">
                <div class="form-group">
                    <label for="mobile" class="required-label">
                        Mobile Number<span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 11
                            digits)</span></label>
                    <input pInputText pKeyFilter="text" class="form-control" inputId="mobile" id="mobile"
                        formControlName="mobile" name="mobile" placeholder="Enter Mobile number" maxlength="11" />
                </div>
                <span class="errormessage"
                    *ngIf="SignatoryForm.get('mobile').invalid && (SignatoryForm.get('mobile').touched  && SignatoryForm.get('mobile').dirty) ">
                    {{getErrorMessage(SignatoryForm,validation_message,'mobile')}}
                </span>
            </div>
        </div>

        <div class="formgrid grid" style="margin-top: 1rem;">
            <div class="col-12 lg:col-4 md:col-4 sm:col-12">&nbsp;
            </div>
        </div>


        <div class="custom-dialog-footer">
            <p-button class="m-1" label="Close" styleClass="customeclose" (click)="dismiss()"></p-button>
            <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave"
                (click)="add()"></p-button>
        </div>

    </form>

</div>